import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { WingBlank, WhiteSpace, Tag, Toast, List, Picker } from 'antd-mobile';
import $ from "jquery";
import * as fun from '../../../components/common';
import './style.less';
let page = 1;
let rows = 10;
let total = 0;
let firstShow = true;
export default class Consume extends Component {
    constructor(props) {
        super(props);
        page = 1;
        rows = 10;
        total = 0;
        this.state = {
            operateList: [],
            cardnum: 0,
            parameter: {
                page: page,
                rows: rows,
                datetime: '',
                type: 1,
                publicId: this.props.match.params.publicId,
                orderlist: [],
                ordervalue: 0,               
            }
        }
    }
    componentDidMount() {
        firstShow = false;
        if (parseInt(this.props.match.params.publicId) === 0) {
            let params = { page: 1, rows: 10 };
            services.GetUserCardList(params, '').then((data) => {
                if (data.status === 0) {
                    if (!!data.result.rows && data.result.rows.length > 0) {
                        let list = (data.result.rows.filter(item => item.cardStatus === 0));
                        const datalist = list.map(function (item) {
                            let obj = {};
                            obj.value = item.publicId;
                            obj.label = item.cardCode + (!!item.ownName ? item.ownName : '');
                            return obj
                        })
                        let cm = [];
                        cm.push(datalist[0].value);
                        let parameter = this.state.parameter;
                        parameter.publicId = datalist[0].value;
                        this.setState(
                            { orderlist: datalist, ordervalue: cm, parameter: parameter, cardnum: data.result.rows },
                            () => {

                                this.GetOperateList();
                            }
                        );
                    }


                } else {
                    Toast.offline(data.message);
                }
            });

        } else {
            this.GetOperateList();
        }

        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total === rows) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }
            timeCount = setTimeout(callback, 50);
        }.bind(this), false);

    }
    GetOperateList = () => {
        const { parameter } = this.state;
        services.GetOperateList(parameter, '').then(data => {
            firstShow = false;
            if (data.status === 0) {
                total = data.result.length;
                this.setState({
                    operateList: data.result,
                });
            } else {
                Toast.offline(data.message);
            }
        })
    }
    //再次加载
    loadMoreDataFn = (page) => {
        let parameter = this.state.parameter;
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetOperateList(parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                total = data.result.length;
                this.setState({
                    operateList: this.state.operateList.concat(data.result),
                });
            } else {
                Toast.offline(data.message);
            }
        })
    }
    onOrder = (e) => {
        $("html,body").animate({
            scrollTop: 0
        }, 0);
        let parameter = this.state.parameter;
        parameter.page = 1;
        parameter.publicId = e[0];
        total = 0;
        page = 1;
        this.setState({ ordervalue: e, parameter: parameter });
        this.GetOperateList();
    }
    render() {
        const { total, operateList, orderlist, ordervalue, cardnum } = this.state;
        return <div className="integral">
            <CommonlyHeadMembers barname="消费记录" />
            {
                parseInt(this.props.match.params.publicId) === 0 ?
                    <div>
                        {
                            cardnum === 0 ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>对不起，您还没有消费记录</p>
                            </div>
                                :

                                <List className="podiv">
                                    <Picker
                                        data={orderlist}
                                        value={ordervalue}
                                        cols={1}
                                        onChange={this.onOrder}
                                    >
                                        <List.Item arrow="horizontal">选择健康积分：</List.Item>
                                    </Picker>
                                </List>
                        }
                        <div className="dodiv"></div>
                    </div>
                    : ''
            }
            <WingBlank size="lg">
                {
                    operateList.length === 0 && firstShow === false ?
                        <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                            <p>该卡还没有消费记录</p>
                        </div> :
                        operateList.map((data, index) => (
                            <div key={index}>
                                <WhiteSpace size="lg" />
                                <div className="consume">
                                    <div className="consume-title">
                                        <div className="title">积分卡号：{data.cardcode}</div>
                                        <Tag className="y" >{data.operatetypeName}</Tag>
                                    </div>
                                    <div className="consume-cen" >
                                        <div className="cname">{!!data.remark ? data.remark : ''}</div>
                                        <div className="cprice y">消费：{data.rechargemoney}</div>
                                    </div>
                                    <div className="consume-cen" >
                                        <div className="cname">{fun.FormatTime(data.createtime, 'yyyy-MM-dd hh:mm')}</div>
                                        <div className="cprice g">剩余：{data.currentmoney}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                <WhiteSpace size="lg" />
                {total === 0 && firstShow === false ?
                    <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                        <p>暂无数据</p>
                    </div>
                    : ''}
                <div ref="wrapper"></div>
            </WingBlank>
        </div>
    }
}